import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import constants from "constants";

const { EXPORT_SPONSORS_CSV } = constants;

function handleExport() {
  axios
    .get(EXPORT_SPONSORS_CSV, { responseType: "blob" })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "clients.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
}

function Tools({
  count,
  deleteUsers,
  // showHideRepresentative,
  // isRepresentative,
}) {
  return (
    <div className="admin_list">
      <h5>
        Clients(<span>{count}</span>)
      </h5>
      {/* <a className="button_classic" onClick={showHideRepresentative}>{isRepresentative ? 'Show all' : 'Show representative'}</a> */}
      <Link className="button_classic" to="/users_sponsors/new">
        Add Client
      </Link>
      <a className="button_classic" onClick={handleExport} href="#">
        Export client details
      </a>
      <a className="button_delete" onClick={deleteUsers}>
        Delete
      </a>
    </div>
  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Admin/UserSponsor/Toolbar/Tools.jsx